import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar solid />
      <main className="pt-16">
        <section className="mx-auto flex min-h-[60vh] w-full max-w-[820px] flex-col items-center justify-center px-4 py-16 text-center">
          <span className="font-heading text-6xl font-bold text-primary-500 md:text-8xl">404</span>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("notFound.title")}
          </h1>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("notFound.desc")}
          </p>
          <Link
            to="/"
            className="mt-7 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            {t("article.backHome")}
          </Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}